import { EXERCISES_DOMAIN } from './domain'
import { EXERCISES_KEY } from './key'

export const EXERCISES_PATH = {
  CURRENT: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.CURRENT}`,
  DATA: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.DATA}`,
  ALL: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.ALL}`,
  ALL_DATA: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.ALL}.data`,
  CREATED: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.CREATED}`,
  CREATED_DATA: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.CREATED}.data`,
  TYPE_TO_IDS: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.TYPE_TO_IDS}`, // BY_QUERY:
  // `${PROFILE_LOGS_DOMAIN}.${REDUX_DOMAIN_LIST_SECTION_KEY.BY_QUERY}`,
  MUSCLE_TO_IDS: `${EXERCISES_DOMAIN}.${EXERCISES_KEY.MUSCLE_TO_IDS}`
}
